import { type TableParamsType } from '../../types/common';
import { type UseQueryResult, useQuery } from 'react-query';
import {
  CompanyBankService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_CompanyBankListDto,
} from '../../services/wealthlane-finance-integration-services';

const useGetCompanyBankList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_CompanyBankListDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo;
  const companyBankList = useQuery(
    ['getCompanyBankList', filter, sorting, skipCount, maxResultCount],
    async () => {
      return await handleRequest(
        CompanyBankService.getApiFinanceIntegrationApiAppCompanyBankCompanyBankList(
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    },
    {
      select: (data) => {
        if (data != null) {
          return data;
        }
      },
    }
  );

  return companyBankList;
};

export default useGetCompanyBankList;
